import { useTranslation } from "react-i18next";
import { summary } from "../data/dados";

export default function ProfessionalSummary() {
  const { t, i18n } = useTranslation('translation', { useSuspense: false });
  
  return (
    <section className="section">
      <h2>{t('title.professionalSummary')}</h2>
      <p>{summary[i18n.language]}</p>
    </section>
  );
}
